import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reset as resetForm } from "redux-form";
import { Map } from "immutable";
import { show as getUser } from "MODULES/users/actions";
import { loadRecord } from "MODULES/shared/decorators";
import { AuditFields, EditButton } from "MODULES/shared/components";
import RecordPager from "MODULES/shared/components/RecordPager";
import {
  ACTIVE,
  ADMIN,
  FIRST_NAME,
  LAST_NAME,
  ROLE,
  SUBROLE,
  USER_ROLES
} from "MODULES/users/constants";
import { LOCATION } from "MODULES/inventories/constants";
import { ID, NAME } from "APP_ROOT/constants";
import VerifyEmail from "MODULES/users/components/VerifyEmail/VerifyEmail";
import EnableMfa from "MODULES/users/components/EnableMfa/EnableMfa";
import EditUser from "../EditUser";
import UpdatePassword from "../UpdatePassword";
import ActivateUser from "../ActivateUser";
import DeactivateUser from "../DeactivateUser";
import { subroleLabel } from "../../helpers";

export class Detail extends Component {
  static propTypes = {
    currentUser: PropTypes.instanceOf(Map),
    user: PropTypes.instanceOf(Map)
  };

  state = {
    editUserModalOpen: false,
    updatePasswordModalOpen: false
  };

  openEditUserModal = () => {
    this.setState({ editUserModalOpen: true });
  };

  closeEditUserModal = () => this.setState({ editUserModalOpen: false });

  openUpdatePasswordModal = () => {
    resetForm("updatePassword");
    this.setState({ updatePasswordModalOpen: true });
  };

  closeUpdatePasswordModal = () =>
    this.setState({ updatePasswordModalOpen: false });

  render() {
    const { currentUser, user } = this.props;
    const { editUserModalOpen, updatePasswordModalOpen } = this.state;

    return (
      <div>
        <div className="page-header page-header-bar">
          <h1>
            {user.get(ID) !== currentUser.get(ID) &&
              (user.get(ACTIVE) ? <DeactivateUser /> : <ActivateUser />)}
            <EnableMfa />
            <VerifyEmail />
            <div className="with-padding">
              {currentUser.get(ROLE) === ADMIN && (
                <RecordPager baseUrl="/users" record={user} />
              )}
              <span>
                <img
                  className="img-circle"
                  src="/assets/images/profile-blank.jpg"
                  alt="profile"
                />
              </span>
              <span>
                {user.get(FIRST_NAME)} {user.get(LAST_NAME)}
              </span>
            </div>
          </h1>
        </div>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <div className="panel panel-default panel-sidebar">
              <div className="panel-body">
                <h2 style={{ marginTop: "10px" }}>
                  Details
                  <EditButton handleClick={this.openEditUserModal} />
                  <EditUser
                    user={user.toJS()}
                    open={editUserModalOpen}
                    close={this.closeEditUserModal}
                  />
                </h2>
                <table className="table table-condensed">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td>
                        {user.get("first_name")} {user.get("last_name")}
                      </td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>
                        <a href={`mailto:${user.get("email")}`}>
                          {user.get("email")}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>Role</th>
                      <td>
                        {USER_ROLES[user.get(ROLE)] &&
                          USER_ROLES[user.get(ROLE)].label}
                      </td>
                    </tr>
                    <tr>
                      <th>Subrole</th>
                      <td>{subroleLabel(user.get(ROLE), user.get(SUBROLE))}</td>
                    </tr>
                    <tr>
                      <th>Location</th>
                      <td>{user.getIn([LOCATION, NAME]) || ""}</td>
                    </tr>
                  </tbody>
                </table>

                <hr className="hr-sm" />
                <h2>
                  Password
                  <button
                    type="button"
                    className="btn btn-primary btn-hollow pull-right"
                    onClick={this.openUpdatePasswordModal}
                  >
                    <i className="fa fa-fw fa-refresh">&nbsp;</i>Update
                  </button>
                  <UpdatePassword
                    open={updatePasswordModalOpen}
                    close={this.closeUpdatePasswordModal}
                  />
                </h2>

                <AuditFields record={user} multiLine />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  user: state.userDetail.get("user"),
  currentUser: state.session.get("user")
}))(
  loadRecord({
    reducer: "userDetail",
    name: "user",
    action: getUser
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/users/components/Detail/Detail.jsx